import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  messages: string[] = [];

  constructor(
    private snackBar: MatSnackBar
  ) { }

  add(message: string) {
    this.messages.push(message);
  }

  showMessages() {
    // TBC
    // this.snackBar.open(this.messages);
  }

  showDirectSimpleMessage(message: string) {
    this.snackBar.open(message,'',{
      duration: 2000,
    } );
  }

  clear() {
    this.messages = [];
  }

}
